import { Component, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { ActionFilter } from '../../Models/Common/ActionFilter';
import { HomeModel } from '../../Models/Home/Home';
import { CommonService } from '../../Services/Common/common.service';
import { HomeService } from '../../Services/Home/home.service';
import { MangeNewsService } from '../../Services/News/mange-news.service';
import { NgbCarousel, NgbSlideEvent, NgbSlideEventSource } from '@ng-bootstrap/ng-bootstrap';
import '@angular/localize/init';
import { MediaService } from '../../Services/Media/media.service';
import { MediaWithPhotos, PhotoGaleryPhotos } from '../../Models/Media/PhotoGaleryPhotos';
@Component({
  selector: 'app-media',
  templateUrl: './media.component.html',
  styleUrls: ['./media.component.css']
})
export class MediaComponent implements OnInit {

  constructor(private MediaService: MediaService,
    private route: ActivatedRoute,
    private HomeService: HomeService,
    private CommonService: CommonService) { }

  Id = this.route.snapshot.paramMap.get("Id");
  Elm: MediaWithPhotos;
  activeSliderId;
 
  goToSlide(slide) {
    this.carousel.select(slide);
  }
  langKey = this.route.snapshot.paramMap.get("langKey") ?? "en";
  Done = false;
  ShowTitle = true;
  ShowBody = true;
  ngOnInit(): void {
    this.HomeService.GetGaleryPhotos(this.langKey, this.Id).subscribe(res => {
      res.elm.photos.forEach((x, i) => {
        x.id = i;
      })
      this.Elm = res.elm;
      this.Done = true;
    });
  }

  paused = false;
  unpauseOnArrow = false;
  pauseOnIndicator = false;
  pauseOnHover = true;
  pauseOnFocus = true;

  @ViewChild('carousel', { static: true }) carousel: NgbCarousel;

  togglePaused() {
    if (this.paused) {
      this.carousel.cycle();
    } else {
      this.carousel.pause();
    }
    this.paused = !this.paused;
  }

  onSlide(slideEvent: NgbSlideEvent) {
    if (this.unpauseOnArrow && slideEvent.paused &&
      (slideEvent.source === NgbSlideEventSource.ARROW_LEFT || slideEvent.source === NgbSlideEventSource.ARROW_RIGHT)) {
      this.togglePaused();
    }
    if (this.pauseOnIndicator && !slideEvent.paused && slideEvent.source === NgbSlideEventSource.INDICATOR) {
      this.togglePaused();
    }
  }
  IsImage(Name: string) {
    Name = Name.split(".")[Name.split('.').length - 1];
    let allImages: Array<string> = ['png', 'jpg', 'jpeg', 'gif', 'tiff', 'bpg'];
    if (allImages.indexOf(Name.toLowerCase()) != -1) {
      return true;
    }
    return false;
  }
}
